import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../styles/styles.scss';
import SourceFlowTracker from "@sourceflow-uk/sourceflow-tracker";

import Layout from '../components/layout'

function MyApp({ Component, pageProps }) {
	return (
		<Layout>
			<SourceFlowTracker />
			<Component {...pageProps} />
		</Layout>
	)
}

export default MyApp
